"use client";
import { DrupalNode } from "next-drupal";
import Image from "next/image";
import React from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import { config } from "@/lib/config";
import Banner from "@/components/sections/Banner";

interface countryProps {
  data: DrupalNode[];
}

const CountryEngagementScreen: React.FC<countryProps> = ({ data }) => {
  const { title = "", field_ce_description = "" } = data[0];
  return (
    <div className="pt-20">
      <Banner
        title={title}
        isRounded
        backgroundImg="/static/images/country-engagement-banner.webp"
      />
      <div className="overflow-hidden">
        <div className="pt-16 pb-8 bg-mapGray mobileMax:pt-8 relative">
          <div className="mini-container relative z-[2]">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0,
              }}
              className="remove-animation-fluctuation mobileMax:w-full --font-poppins text-medium text-center mb-5 mt-3 leading-8 text-[#003350] mobileMax:mb-5 mobileMax:text-xsmall mobileMax:leading-normal"
              dangerouslySetInnerHTML={{
                __html: field_ce_description?.processed,
              }}
            />
          </div>
        </div>
        {/* country card */}
        <div className="pt-16 pb-20 bg-mapGray mobileMax:pb-8 mobileMax:pt-8 relative">
          <div className="mini-container relative z-[2]">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0,
              }}
              className="remove-animation-fluctuation desktop:text-[56px] text-numans mb-[30px] leading-normal text-center bg-[linear-gradient(to_top,#8EBCE5,#11375C)] text-clip text-[48px] mobileMax:text-[28px] mobileMax:px-0 mobileMax:mb-5"
            >
              Countries
            </motion.h2>
            <div className="flex justify-center box-border">
              <Link
                href="/country-engagement/india"
                className="remove-animation-fluctuation animate-cardHover-speed px-[15px] mb-[30px] w-[33%] mobileMax:w-full mobileMax:px-0 mobileMax:mb-[15px] cursor-pointer"
              >
                <motion.div
                  className="animate-cardHover-speed flex items-center flex-col box-border h-full w-full rounded-[23px] overflow-hidden card-shadow bg-white p-4"
                  whileHover={{ scale: 1.02 }}
                  transition={{
                    duration: 0,
                  }}
                >
                  <Image
                    src={`/static/images/Flag_of_India.webp`}
                    alt="category img"
                    height={200}
                    width={200}
                    className="h-full w-full mb-5"
                  />
                  <h4 className="--font-poppins text-center text-[22px] text-[#003350] tracking-[0.5px] uppercase leading-7 mobileMax:text-medium mobileMax:leading-7 hover:underline">
                    India
                  </h4>
                </motion.div>
              </Link>
              <Link
                href="/country-engagement/kenya"
                className="remove-animation-fluctuation animate-cardHover-speed px-[15px] mb-[30px] w-[33%] mobileMax:w-full mobileMax:px-0 mobileMax:mb-[15px] cursor-pointer"
              >
                <motion.div
                  className="animate-cardHover-speed flex items-center flex-col box-border h-full w-full rounded-[23px] overflow-hidden card-shadow bg-white p-4"
                  whileHover={{ scale: 1.02 }}
                  transition={{
                    duration: 0,
                  }}
                >
                  <Image
                    src={`/static/flags/ke.svg`}
                    alt="category img"
                    height={200}
                    width={200}
                    className="h-full w-full mb-5"
                  />
                  <h4 className="--font-poppins text-center text-[22px] text-[#003350] tracking-[0.5px] uppercase leading-7 mobileMax:text-medium mobileMax:leading-7 hover:underline">
                    Kenya
                  </h4>
                </motion.div>
              </Link>
              <Link
                href="/country-engagement/asean"
                className="remove-animation-fluctuation animate-cardHover-speed px-[15px] mb-[30px] w-[33%] mobileMax:w-full mobileMax:px-0 mobileMax:mb-[15px] cursor-pointer"
              >
                <motion.div
                  className="animate-cardHover-speed flex items-center flex-col box-border h-full w-full rounded-[23px] overflow-hidden card-shadow bg-white p-4"
                  whileHover={{ scale: 1.02 }}
                  transition={{
                    duration: 0,
                  }}
                >
                  <Image
                    src={`/static/images/asean.png`}
                    alt="category img"
                    height={200}
                    width={200}
                    className="h-full w-full mb-5"
                  />
                  <h4 className="--font-poppins text-center text-[22px] text-[#003350] tracking-[0.5px] uppercase leading-7 mobileMax:text-medium mobileMax:leading-7 hover:underline">
                    Southeast Asia
                  </h4>
                </motion.div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryEngagementScreen;
